/** Evento global para focar uma seção do editor (paleta Ctrl+K). */
export const FOCUS_SECTION_EVENT = "formatafacil:focus-section";

/** Disparado quando qualquer paleta de comandos (cmdk) abre — fecha o menu "/" no editor. */
export const COMMAND_PALETTE_OPEN_EVENT = "formatafacil:command-palette-open";

/** Disparado para alternar o modo de foco (ocultar/exibir barras de navegação). */
export const FOCUS_MODE_TOGGLE_EVENT = "formatafacil:focus-mode-toggle";
